// Many legacy tests carry no average duration; the business fallback is 70% of
// the max duration.
export const AVERAGE_FROM_MAX_RATIO = 0.7;

/**
 * Average duration of a test level in seconds, falling back to 70% of the max
 * duration when the average is missing. Returns 0 when neither is available, so
 * callers can hide their duration line.
 */
export const effectiveAverageDuration = ({ averageDuration, maxDuration } = {}) => {
    if (averageDuration > 0) return averageDuration;
    if (maxDuration > 0) return Math.round(maxDuration * AVERAGE_FROM_MAX_RATIO);
    return 0;
};
